import { render, staticRenderFns } from "./DistrictsText.vue?vue&type=template&id=a0554aaa&"
import script from "./DistrictsText.vue?vue&type=script&lang=js&"
export * from "./DistrictsText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports